
        var result = require("!!../../../../node_modules/css-loader/index.js!./reason.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/reason/reason.component.css
// module id = 775
// module chunks = 0